import ImageWithBasePath from "@/components/image-with-base-path"
import { all_routes } from "@/routes/all_routes"
import { Link } from "react-router"


const ServicesSection = () => {
  return (
   <>
  {/* Services Section Start */}
  <section className="services-section-fourteen section">
    <div className="container">
      <div
        className="section-header section-header-fourteen title-white section-btn wow fadeInUp"
        data-wow-duration="1s"
      >
        <div>
          <h2 className="section-title">
            Medical <span className="section-line">Dermatology</span>{" "}
            <span className="subtitle">to Aesthetic Treatments</span>
          </h2>
        </div>
        <Link to={all_routes.register} className="btn btn-secondary theme-14-btn">
          <i className="isax isax-bubble5 me-2" />
          View All Services
        </Link>
      </div>
      <div className="services-content-fourteen d-flex gap-4">
        {/* Item 1 */}
        <div
          className="services-item-fourteen wow fadeInUp"
          data-wow-duration="1s"
        >
          <h3 className="title">Acne Treatment</h3>
          <div className="services-info">
            <div className="services-content">
              <h3 className="custom-title">Acne Treatment</h3>
              <p>
                Evidence-based solutions for clearer, healthier skin at any age
              </p>
            </div>
            <Link to={all_routes.speciality} className="view-icon">
              <i className="isax isax-arrow-right-1" />
            </Link>
          </div>
          <div className="services-profile">
            <ImageWithBasePath
              src="assets/img/service/service-thumb-01.jpg"
              alt="services"
              className="img-fluid thumb-img"
            />
            <ImageWithBasePath
              src="assets/img/service/service-lg-01.jpg"
              alt="services"
              className="img-fluid large-img"
            />
          </div>
        </div>
        {/* Item 2 */}
        <div
          className="services-item-fourteen wow fadeInUp"
          data-wow-duration="2s"
        >
          <h3 className="title">Anti Aging Care</h3>
          <div className="services-info">
            <div className="services-content">
              <h3 className="custom-title">Anti Aging Care</h3>
              <p>
                Evidence-based solutions for clearer, healthier skin at any age
              </p>
            </div>
            <Link to={all_routes.speciality} className="view-icon">
              <i className="isax isax-arrow-right-1" />
            </Link>
          </div>
          <div className="services-profile">
            <ImageWithBasePath
              src="assets/img/service/service-thumb-02.jpg"
              alt="services"
              className="img-fluid thumb-img"
            />
            <ImageWithBasePath
              src="assets/img/service/service-lg-02.jpg"
              alt="services"
              className="img-fluid large-img"
            />
          </div>
        </div>
        {/* Item 3 */}
        <div
          className="services-item-fourteen wow fadeInUp"
          data-wow-duration="3s"
        >
          <h3 className="title">Cosmetic Procedures</h3>
          <div className="services-info">
            <div className="services-content">
              <h3 className="custom-title">Cosmetic Procedures</h3>
              <p>Advanced cosmetic solutions for radiant, flawless skin</p>
            </div>
            <Link to={all_routes.speciality} className="view-icon">
              <i className="isax isax-arrow-right-1" />
            </Link>
          </div>
          <div className="services-profile">
            <ImageWithBasePath
              src="assets/img/service/service-thumb-03.jpg"
              alt="services"
              className="img-fluid thumb-img"
            />
            <ImageWithBasePath
              src="assets/img/service/service-lg-03.jpg"
              alt="services"
              className="img-fluid large-img"
            />
          </div>
        </div>
        {/* Item 4 */}
        <div
          className="services-item-fourteen wow fadeInUp"
          data-wow-duration="4s"
        >
          <h3 className="title">Laser Therapy</h3>
          <div className="services-info">
            <div className="services-content">
              <h3 className="custom-title">Laser Therapy</h3>
              <p>Laser therapy for acne scars and skin tightening</p>
            </div>
            <Link to={all_routes.speciality} className="view-icon">
              <i className="isax isax-arrow-right-1" />
            </Link>
          </div>
          <div className="services-profile">
            <ImageWithBasePath
              src="assets/img/service/service-thumb-04.jpg"
              alt="services"
              className="img-fluid thumb-img"
            />
            <ImageWithBasePath
              src="assets/img/service/service-lg-04.jpg"
              alt="services"
              className="img-fluid large-img"
            />
          </div>
        </div>
      </div>
    </div>
    <ImageWithBasePath
      src="assets/img/bg/team-bg-02.png"
      alt="bg"
      className="img-fluid service-bg"
    />
  </section>
  {/* Services Section Start */}
</>

  )
}

export default ServicesSection